__turbopack_context__.v({
  "actions": "KibbePhotoInput-module__ehNcHq__actions",
  "empty": "KibbePhotoInput-module__ehNcHq__empty",
  "guidance": "KibbePhotoInput-module__ehNcHq__guidance",
  "icon": "KibbePhotoInput-module__ehNcHq__icon",
  "portrait": "KibbePhotoInput-module__ehNcHq__portrait",
  "preview": "KibbePhotoInput-module__ehNcHq__preview",
  "root": "KibbePhotoInput-module__ehNcHq__root",
  "selected": "KibbePhotoInput-module__ehNcHq__selected",
  "status": "KibbePhotoInput-module__ehNcHq__status",
  "surface": "KibbePhotoInput-module__ehNcHq__surface",
});
